import React from 'react';
import { Container } from 'react-bootstrap';

const Footer = () => {
    return (
        <footer className="footer">
            <Container>
                <div className="container small-font no-print" >
                    <p>&copy; {new Date().getFullYear()} Digital Computer Exchange, Inc. All rights reserved.</p>
                </div>
            </Container>
        </footer>
    );
};

export default Footer;